// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"0911f870","519":"cecd848b","521":"21f257d0","777":"aa2058d0","804":"569ebe9a","943":"6d81929b","944":"66913f22"}[chunkId] + ".chunk.js";
};